import { c as _c } from "react/compiler-runtime";
import type { Container, ServiceIdentifier } from 'inversify';
import { useContainer } from 'inversify-react';
export function useNamedInjection(serviceId, named) {
  const $ = _c(3);
  let t0;
  if ($[0] !== named || $[1] !== serviceId) {
    t0 = container => container.get(serviceId, {
      name: named
    });
    $[0] = named;
    $[1] = serviceId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useContainer(t0);
}